// ─── Routes ────────────────────────────────────────────────────────────────
export const ROUTE_PATHS = {
  HOME: '/',
} as const;

// ─── Types ──────────────────────────────────────────────────────────────────
export interface NavItem {
  label: string;
  labelEs: string;
  href: string;
}

export interface TeamMember {
  name: string;
  role: string;
  roleEs: string;
}

export interface Service {
  icon: string;
  title: string;
  titleEs: string;
  description: string;
  descriptionEs: string;
}

export interface ODS {
  number: number;
  color: string;
  title: string;
  titleEs: string;
  description: string;
  descriptionEs: string;
  logo: string;
}

export interface Testimonial {
  name: string;
  location: string;
  text: string;
  textEs: string;
  rating: number;
  image: string;
}

export interface GalleryImage {
  src: string;
  alt: string;
  altEs: string;
}

// ─── Data ────────────────────────────────────────────────────────────────────
export const NAV_ITEMS: NavItem[] = [
  { label: 'Sobre Nosaltres', labelEs: 'Sobre Nosotros', href: '#about' },
  { label: 'Serveis', labelEs: 'Servicios', href: '#services' },
  { label: 'ODS', labelEs: 'ODS', href: '#ods' },
  { label: 'Equip', labelEs: 'Equipo', href: '#team' },
  { label: 'Galeria', labelEs: 'Galeria', href: '#gallery' },
  { label: 'Contacte', labelEs: 'Contacto', href: '#contact' },
];

export const TEAM_MEMBERS: TeamMember[] = [
  { name: 'Maria Magdalena Pastor', role: 'Co-fundadora & Directora', roleEs: 'Co-fundadora & Directora' },
  { name: 'Francina Segura', role: 'Co-fundadora & Relacions amb clients', roleEs: 'Co-fundadora & Relaciones con clientes' },
  { name: 'Margalida Ferrer', role: "Co-fundadora & Gestio d'allotjaments", roleEs: 'Co-fundadora & Gestion de alojamientos' },
  { name: 'Alba Garcia', role: 'Co-fundadora & Marqueting', roleEs: 'Co-fundadora & Marketing' },
  { name: 'Mariana Moreno', role: 'Co-fundadora & Logistica i transport', roleEs: 'Co-fundadora & Logistica y transporte' },
];

export const ODS_LIST: ODS[] = [
  {
    number: 3,
    color: '#4C9A2A',
    logo: '/images/ods_3_official.png',
    title: 'Salut i Benestar',
    titleEs: 'Salud y Bienestar',
    description: "Garantim allotjaments segurs i accessibles, col·laborant amb entitats sanitaries per assegurar el benestar fisic i emocional de cada client.",
    descriptionEs: "Garantizamos alojamientos seguros y accesibles, colaborando con entidades sanitarias para asegurar el bienestar fisico y emocional de cada cliente.",
  },
  {
    number: 9,
    color: '#F36D25',
    logo: '/images/ods_9_official.jpg',
    title: "Industria, Innovacio i Infraestructures",
    titleEs: 'Industria, Innovacion e Infraestructuras',
    description: "Promovem infraestructures adaptades i accessibles, facilitant solucions innovadores que milloren la qualitat de vida de les persones amb mobilitat reduida.",
    descriptionEs: "Promovemos infraestructuras adaptadas y accesibles, facilitando soluciones innovadoras que mejoran la calidad de vida de las personas con movilidad reducida.",
  },
  {
    number: 10,
    color: '#DD1367',
    logo: '/images/ods_10_official.jpg',
    title: 'Reduccio de les Desigualtats',
    titleEs: 'Reduccion de las Desigualdades',
    description: "Treballem activament per reducir les desigualtats socials, assegurant que totes les persones, independentment de les seves capacitats, puguin gaudir d'unes vacances dignes.",
    descriptionEs: "Trabajamos activamente para reducir las desigualdades sociales, asegurando que todas las personas, independientemente de sus capacidades, puedan disfrutar de unas vacaciones dignas.",
  },
];

export const SERVICES: Service[] = [
  {
    icon: '🏠',
    title: 'Allotjament 100% Verificat',
    titleEs: 'Alojamiento 100% Verificado',
    description: "Inspeccionem personalment cada allotjament per garantir l'accessibilitat real: rampes, banys adaptats, espais amplis i sense barreres arquitectoniques.",
    descriptionEs: "Inspeccionamos personalmente cada alojamiento para garantizar la accesibilidad real: rampas, banos adaptados, espacios amplios y sin barreras arquitectonicas.",
  },
  {
    icon: '🚐',
    title: 'Transport Adaptat',
    titleEs: 'Transporte Adaptado',
    description: "Vehicles adaptats des de l'aeroport fins a l'allotjament i per a totes les excursions. Viatges comodes i segurs per a persones en cadira de rodes.",
    descriptionEs: "Vehiculos adaptados desde el aeropuerto hasta el alojamiento y para todas las excursiones. Viajes comodos y seguros para personas en silla de ruedas.",
  },
  {
    icon: '🌊',
    title: 'Activitats Inclusives',
    titleEs: 'Actividades Inclusivas',
    description: "Excursions i activitats turistiques pensades per a tothom: platges accessibles, rutes sense barreres i experiencies uniques al cor de Mallorca.",
    descriptionEs: "Excursiones y actividades turisticas pensadas para todos: playas accesibles, rutas sin barreras y experiencias unicas en el corazon de Mallorca.",
  },
  {
    icon: '👥',
    title: 'Assessorament Personalitzat',
    titleEs: 'Asesoramiento Personalizado',
    description: "Atencio individualitzada abans, durant i despres del viatge. Entenem les necessitats especifiques de cada persona per oferir el millor servei possible.",
    descriptionEs: "Atencion individualizada antes, durante y despues del viaje. Entendemos las necesidades especificas de cada persona para ofrecer el mejor servicio posible.",
  },
];

export const TESTIMONIALS: Testimonial[] = [
  {
    name: 'Josep M. Riera',
    location: 'Barcelona',
    text: "Finalment unes vacances on tot estava realment adaptat. Liberum va verificar personalment l'allotjament i l'experiencia va ser perfecta. Tornarem segur!",
    textEs: "Por fin unas vacaciones donde todo estaba realmente adaptado. Liberum verifico personalmente el alojamiento y la experiencia fue perfecta. Volveremos seguro!",
    rating: 5,
    image: '/images/inclusive_9.jpeg',
  },
  {
    name: 'Marta i familia',
    location: 'Valencia',
    text: "El meu fill utilitza cadira de rodes i mai haviem gaudit tant d'unes vacances. L'equip de Liberum va cuidar cada detall amb una professionalitat i humanitat excepcionals.",
    textEs: "Mi hijo usa silla de ruedas y nunca habiamos disfrutado tanto de unas vacaciones. El equipo de Liberum cuido cada detalle con una profesionalidad y humanidad excepcionales.",
    rating: 5,
    image: '/images/inclusive_10.jpeg',
  },
  {
    name: 'Ana Gonzalez',
    location: 'Madrid',
    text: "Descobrir les platges de Mallorca sense preocupacions d'accessibilitat ha estat un somni fet realitat. Liberum ho fa possible amb molta dedicacio i calidesa humana.",
    textEs: "Descubrir las playas de Mallorca sin preocupaciones de accesibilidad ha sido un sueno hecho realidad. Liberum lo hace posible con mucha dedicacion y calidez humana.",
    rating: 5,
    image: '/images/inclusive_5.jpeg',
  },
];

export const GALLERY_IMAGES: GalleryImage[] = [
  { src: '/images/gallery/family_joy_disability_1.jpeg', alt: 'Familia gaudint de les vacances a la ciutat amb cadira de rodes', altEs: 'Familia disfrutando de las vacaciones en la ciudad con silla de ruedas' },
  { src: '/images/gallery/wheelchair_holiday_joy_1.jpeg', alt: 'Grup d\'amics amb cadira de rodes passejant per un poble costaner', altEs: 'Grupo de amigos con silla de ruedas paseando por un pueblo costero' },
  { src: '/images/gallery/wheelchair_holiday_joy_2.jpeg', alt: 'Pare i fill gaudint d\'unes vacances accessibles a Espanya', altEs: 'Padre e hijo disfrutando de unas vacaciones accesibles en España' },
  { src: '/images/gallery/wheelchair_holiday_joy_3.jpeg', alt: 'Dona en cadira de rodes contemplant un paisatge espectacular', altEs: 'Mujer en silla de ruedas contemplando un paisaje espectacular' },
  { src: '/images/gallery/wheelchair_holiday_joy_5.jpeg', alt: 'Persona en cadira de rodes practicant surf adaptat', altEs: 'Persona en silla de ruedas practicando surf adaptado' },
  { src: '/images/gallery/wheelchair_holiday_joy_7.jpeg', alt: 'Dues dones en un tricicle adaptat passejant amb alegria', altEs: 'Dos mujeres en un triciclo adaptado paseando con alegría' },
];

// ─── Utils ───────────────────────────────────────────────────────────────────
export function scrollToSection(id: string): void {
  const el = document.getElementById(id);
  if (el) {
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}

export type Lang = 'ca' | 'es';
